export default {
  currency: undefined,
  currencies: [],
};
